import React from 'react';
import { Row, Col } from 'react-bootstrap';
import ColumnHeader from 'components/NewHome/Table/ColumnHeader';
import Button from 'components/DesignSystem/Button';
import useFluxQueue from 'hooks/NewHome/Table/FluxQueue/useFluxQueue';

export default function FluxQueue() {
  const {
    title,
    execution,
    setTitle,
    setExecution,
    clearFilters,
    titleOptions,
    executionOptions,
    filteredItems,
  } = useFluxQueue();

  return (
    <div>
      <Row className="d-flex justify-content-end">
        <Col md="2" className="d-flex justify-content-end me-3">
          <Button
            type="tertiary"
            icon="no_filter"
            onClick={clearFilters}
          >
            Limpar Filtros
          </Button>
        </Col>
      </Row>
      <div className="ms-2 me-2">
        <Row className="mb-1 mt-2 ht-row">
          <ColumnHeader md={9} title="Título" className="mr-3" value={title} setValue={setTitle}>
            {titleOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
          <ColumnHeader md={3} title="Em execução" value={execution} setValue={setExecution}>
            {executionOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </ColumnHeader>
        </Row>
        <div className="ht-row-container">
          {filteredItems.map((item) => (
            <Row key={`flux-queue-${item.id}`} className="pt-3 pb-3 ht-row ht-entry-row">
              <Col md={9} className="home-table-entry-name">{item.title}</Col>
              <Col md={3} className="home-table-entry-attr">{item.execution}</Col>
            </Row>
          ))}
        </div>
      </div>
    </div>
  );
}
